// header.js — the pickup flyout (Figma 13813:15126) with its postal-code
// match, and the nav dropdowns' edge nudge and Escape handling.
//
// Same guard + rescan() pattern as app.js/drawer.js: a duplicate <script>
// is a no-op, and shopify:section:load re-binds to the fresh header DOM.
//
// Postal match: without scripting the flyout form GETs the locator page
// with ?postal=. With scripting it is answered in place by TMG_STORE_MATCH
// (store-match.js, loaded first) using the 250 km FSA rule, so the flyout
// names the same store as the homepage band, locator and inquiry forms.
// The answer is saved and broadcast (tmg:store), so the pill shows the
// visitor's store on later pages. The theme editor ignores the saved
// answer. Rows find their store by data-store-name.
//
// Dropdowns open via :hover/:focus-within in header.css; this file only
// keeps a panel inside the window (--dd-x) and lets Escape dismiss it
// (WCAG 1.4.13). Opening the pickup panel closes the phone menu first.
if (!window.__tmgHeader) {
  (function () {
    var open = null; // { trigger, panel }

    function show(entry) {
      if (open && open.panel === entry.panel) return;
      hide();
      entry.panel.hidden = false;
      entry.trigger.setAttribute('aria-expanded', 'true');
      open = entry;
    }

    function hide(refocus) {
      if (!open) return;
      open.panel.hidden = true;
      open.trigger.setAttribute('aria-expanded', 'false');
      if (refocus && open.trigger.offsetParent !== null) open.trigger.focus();
      open = null;
    }

    function wire(trigger, panel) {
      if (!trigger || !panel || trigger.dataset.hdBound) return;
      trigger.dataset.hdBound = '1';
      trigger.setAttribute('aria-expanded', 'false');
      if (panel.id) trigger.setAttribute('aria-controls', panel.id);
      var entry = { trigger: trigger, panel: panel };
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (open && open.panel === panel) {
          hide();
        } else {
          if (window.__tmgDrawer && window.__tmgDrawer.close) window.__tmgDrawer.close();
          show(entry);
          var field = panel.querySelector('input');
          // a phone would pop its keyboard and jump the page the moment the
          // panel opened, which kept the dropdown from showing
          if (field && !matchMedia('(pointer: coarse)').matches) field.focus();
        }
      });
      // A click inside a panel must not count as "outside".
      panel.addEventListener('click', function (e) {
        e.stopPropagation();
      });
    }

    // ---------- postal match ----------
    function designMode() {
      return !!(window.Shopify && window.Shopify.designMode);
    }

    // Repaints one pickup control for match result `r`; null puts the pill
    // back to its configured text and the rows back in the merchant's order.
    function paint(root, r) {
      var M = window.TMG_STORE_MATCH;
      var pre = root.querySelector('.pk-pre');
      var name = root.querySelector('.pk-store');
      if (!M || !pre || !name) return;
      if (!root.hasAttribute('data-default-pre')) {
        root.setAttribute('data-default-pre', pre.textContent);
        root.setAttribute('data-default-store', name.textContent);
      }

      var rows = Array.prototype.slice.call(root.querySelectorAll('[data-store-name]'));
      rows.forEach(function (li, i) {
        if (!li.hasAttribute('data-order')) li.setAttribute('data-order', String(i));
      });
      rows.sort(function (a, b) {
        return +a.getAttribute('data-order') - +b.getAttribute('data-order');
      });

      var hit = null;
      rows.forEach(function (li) {
        var on = !!(r && r.store && M.keyOf(li.getAttribute('data-store-name')) === r.store);
        li.classList.toggle('is-match', on);
        var tag = li.querySelector('.pk-you');
        if (tag) tag.hidden = !on;
        if (on && !hit) hit = li;
      });

      var list = root.querySelector('.pk-list');
      if (list) {
        rows.forEach(function (li) {
          list.appendChild(li);
        });
        if (hit) list.insertBefore(hit, list.firstChild);
      }

      if (r && r.store) {
        pre.textContent = root.getAttribute('data-default-pre');
        name.textContent = hit ? hit.getAttribute('data-store-name') : r.name;
      } else if (r) {
        pre.textContent = root.getAttribute('data-outside-label') || root.getAttribute('data-default-pre');
        name.textContent = r.code;
      } else {
        pre.textContent = root.getAttribute('data-default-pre');
        name.textContent = root.getAttribute('data-default-store');
      }
    }

    function say(root, text) {
      var msg = root.querySelector('.pk-msg');
      if (msg) msg.textContent = text || '';
    }

    function onPickupSubmit(e) {
      var M = window.TMG_STORE_MATCH;
      var form = e.currentTarget;
      var root = form.closest('[data-pickup]');
      var field = form.querySelector('input[name="postal"]');
      if (!M || !root || !field) return; // no matcher: let the GET take the visitor to the locator
      e.preventDefault();

      var r = M.match(field.value);
      if (!r) {
        say(root, root.getAttribute('data-msg-invalid'));
        field.focus();
        return;
      }
      M.save(r); // fires tmg:store, which repaints every pickup control
      var hit = root.querySelector('.pk-list .is-match');
      var storeName = hit ? hit.getAttribute('data-store-name') : r.name;
      say(root, M.fill(root.getAttribute(r.store ? 'data-msg-match' : 'data-msg-outside'), r, storeName));
    }

    // ---------- nav dropdowns ----------
    // Measures each panel with its nudge cleared (the rect includes the
    // centring transform) and writes the shift that keeps it 16px inside
    // the window. A panel wider than the window is centred on it. Hidden
    // panels are laid out too, so this also stops a closed one from
    // reaching past the edge.
    function fitDropdowns() {
      var edge = 16;
      var vw = document.documentElement.clientWidth;
      document.querySelectorAll('.has-dd .dd').forEach(function (dd) {
        dd.style.setProperty('--dd-x', '0px');
        var r = dd.getBoundingClientRect();
        if (!r.width) return; // nav hidden at this width
        var x = 0;
        if (r.width > vw - 2 * edge) x = (vw - r.width) / 2 - r.left;
        else if (r.left < edge) x = edge - r.left;
        else if (r.right > vw - edge) x = vw - edge - r.right;
        dd.style.setProperty('--dd-x', Math.round(x) + 'px');
      });
    }
    var fitQueued = false;
    function queueFit() {
      if (fitQueued) return;
      fitQueued = true;
      requestAnimationFrame(function () {
        fitQueued = false;
        fitDropdowns();
      });
    }

    function shut(item) {
      if (!item) return;
      item.classList.add('dd-shut');
      var link = item.querySelector('.nav-link');
      if (item.contains(document.activeElement) && link && document.activeElement !== link) link.focus();
    }

    function bind() {
      open = null;
      document.querySelectorAll('.has-dd').forEach(function (item) {
        if (item.dataset.ddBound) return;
        item.dataset.ddBound = '1';
        item.addEventListener('mouseenter', queueFit);
        item.addEventListener('focusin', queueFit);
        item.addEventListener('mouseleave', function () {
          if (!item.contains(document.activeElement)) item.classList.remove('dd-shut');
        });
        item.addEventListener('focusout', function (e) {
          if (!item.contains(e.relatedTarget) && !item.matches(':hover')) item.classList.remove('dd-shut');
        });
      });
      queueFit();
      var M = window.TMG_STORE_MATCH;
      var saved = M && !designMode() ? M.saved() : null;
      document.querySelectorAll('[data-pickup]').forEach(function (root) {
        wire(root.querySelector('.pk-pill'), root.querySelector('.pk-panel'));
        var form = root.querySelector('.pk-form');
        if (form && !form.dataset.pkBound) {
          form.dataset.pkBound = '1';
          form.addEventListener('submit', onPickupSubmit);
        }
        if (saved) paint(root, saved);
      });
      // the search control and its panel belong to search-panel.js
    }

    document.addEventListener('click', function () {
      hide();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var a = document.activeElement;
      var focused = a && a.closest ? a.closest('.has-dd') : null;
      var hovered = document.querySelector('.has-dd:hover');
      if (focused || hovered) {
        shut(focused);
        shut(hovered);
        return;
      }
      hide(true);
    });
    addEventListener('resize', queueFit, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queueFit);
    document.addEventListener('tmg:store', function (e) {
      document.querySelectorAll('[data-pickup]').forEach(function (root) {
        paint(root, e.detail);
      });
    });
    document.addEventListener('shopify:section:load', function () {
      window.__tmgHeader.rescan();
    });

    bind();
    window.__tmgHeader = { rescan: bind };
  })();
}
